import { useEffect, useState } from "react";
import axios from "axios";
import { Eye, Check, Ban, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useSiteContent } from "@/hooks/useSiteContent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Banner mostrado cuando el admin abre el sitio con ?preview=<action_id>:
   ve los cambios propuestos por la IA aplicados y puede confirmarlos o cancelarlos. */
export const SitePreviewBanner = () => {
  const { previewId, isPreview } = useSiteContent();
  const { isAdmin, authHeader } = useAuth();
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!previewId) return undefined;
    const prev = document.body.style.paddingTop;
    document.body.style.paddingTop = "40px";
    return () => { document.body.style.paddingTop = prev; };
  }, [previewId]);
  if (!previewId) return null;

  const exit = () => { window.location.href = window.location.pathname; };
  const act = async (kind) => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/assistant/actions/${previewId}/${kind}`, {}, { headers: authHeader() });
      toast.success(kind === "confirm" ? (r.data?.result || "Cambios aplicados") : "Propuesta cancelada");
      setTimeout(exit, 800);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo completar");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="site-preview-banner" className="fixed top-0 inset-x-0 z-[90] bg-sky-600 text-white text-xs sm:text-sm px-3 py-2 flex flex-wrap items-center justify-center gap-2 shadow-lg">
      <Eye className="w-4 h-4" />
      <span className="font-semibold">{isPreview ? "Vista previa de cambios pendientes" : "Esta propuesta ya no está pendiente"}</span>
      {isAdmin && isPreview && (
        <>
          <button data-testid="site-preview-confirm" disabled={busy} onClick={() => act("confirm")} className="ml-2 inline-flex items-center gap-1 px-3 py-1 rounded-full bg-emerald-400 text-black font-bold uppercase tracking-widest text-[10px] disabled:opacity-50">
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />} Confirmar cambios
          </button>
          <button data-testid="site-preview-cancel" disabled={busy} onClick={() => act("cancel")} className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-white/50 uppercase tracking-widest text-[10px]">
            <Ban className="w-3 h-3" /> Cancelar
          </button>
        </>
      )}
      <button data-testid="site-preview-exit" onClick={exit} className="inline-flex items-center gap-1 px-2 py-1 rounded-full hover:bg-white/15 uppercase tracking-widest text-[10px]"><X className="w-3 h-3" /> Salir</button>
    </div>
  );
};

export default SitePreviewBanner;
